import React from 'react';
import { useAnalytics } from '../hooks/useAnalytics';

// Wrapper component that enables analytics tracking for all routes
const AnalyticsWrapper = ({ children }) => {
  // This hook automatically tracks page views on route changes
  useAnalytics();
  
  return <>{children}</>;
};

export default AnalyticsWrapper;